import React, { useState, useEffect } from "react";
import "../BackendStyle.css";
import { URLs } from "../Url";
import {
  GetBenefitmeals,
  handlePostImage,
  BenefitmealUpload,
  BenefitmealUpdate,
  handledeleteImage,
  DeleteBenefitmeal,
} from "./config";
function BenefitsMeal() {
  const [data, setdata] = useState([]);
  const [title, settitle] = useState();
  const [description, setdescription] = useState();

  const [image, setimage] = useState();
  const [updateimage, setupdateimage] = useState();
  const [deleteimage, setdeleteimage] = useState();
  const [UpdateId, setUpdateId] = useState();

  const [isLoading, setisLoading] = useState(true);
  const [show, setShow] = useState(true);
  useEffect(() => {
    handlerData();
  }, []);
  const handlerData = async () => {
    const getgteanData = await GetBenefitmeals();
    if (getgteanData.success == true) {
      console.log(getgteanData);
      setdata(getgteanData.data);
    }
  };
  const handlerUpdateData = async (Getimage) => {
    const ImageCheck = updateimage == undefined ? image : Getimage;

    const getgteanData = await BenefitmealUpdate(
      UpdateId,
      title,
      description,
      ImageCheck
    );
    if (getgteanData.success == true) {
      handlerData();
      if (updateimage != undefined) {
        ImageDeleteHandler(deleteimage);
        UpdateVar();
      }
      setShow(true);
    }
  };
  const handleImage = async () => {
    if (image != undefined) {
      const GetData = await handlePostImage(image);
      if (GetData.success == true) {
        if (show == "update") {
          handlerUpdateData(GetData.image);
        } else {
          handlerUploadData(GetData.image);
        }
      }
    } else {
      handlerUploadData();
    }
  };
  const handlerUploadData = async (Getimage) => {
    const getgteanData = await BenefitmealUpload(title, description, Getimage);
    if (getgteanData.success == true) {
      handlerData();

      setShow(true);
    }
  };
  const ImageDeleteHandler = async (imageDelete) => {
    const getResponse = await handledeleteImage(imageDelete);
    if (getResponse.success == true) {
      UpdateVar();
    }
  };
  const handlerDelete = async (id, imageId) => {
    const getgteanData = await DeleteBenefitmeal(id);
    if (getgteanData.success == true) {
      ImageDeleteHandler(imageId);
      handlerData();
    }
  };
  const UpdateItem = (item) => {
    settitle(item.title);
    setdescription(item.description);
    setimage(item.image);
    setdeleteimage(item.image);
    setUpdateId(item._id);
    setShow("update");
  };
  const UpdateVar = () => {
    settitle();
    setdescription();
    setimage();
    setupdateimage();
    setdeleteimage();
    setUpdateId();
  };
  console.log(updateimage);
  const onImageChange = (event) => {
    if (event.target.files && event.target.files[0]) {
      setupdateimage(URL.createObjectURL(event.target.files[0]));
      setimage(event.target.files[0]);
    }
  };

  return (
    <>
      {show == "update" ? (
        <div className="cus-contact">
          <form>
            {/* <h3>About Us</h3> */}
            <div className="form-group">
              <label>Title</label>
              <input
                class="form-control"
                value={title}
                onChange={(e) => settitle(e.target.value)}
              ></input>
            </div>
            <div className="form-group">
              <label>Description</label>
              <input
                class="form-control"
                value={description}
                onChange={(e) => setdescription(e.target.value)}
              ></input>
            </div>

            <div className="form-group">
              <label>Image</label>
              <input
                type="file"
                className="form-control"
                // value={link2}
                name="image"
                onChange={onImageChange}
              />
            </div>
            <div className="form-group">
              {updateimage == undefined ? (
                <img
                  src={URLs.images + image}
                  alt=""
                  className="img-fluid"
                  style={{ width: 200, height: 200 }}
                />
              ) : (
                <img
                  src={updateimage}
                  alt=""
                  className="img-fluid"
                  style={{ width: 200, height: 200 }}
                />
              )}
            </div>
            <button
              onClick={() => {
                if (updateimage == undefined) {
                  handlerUpdateData();
                } else {
                  handleImage();
                }
              }}
              type="button"
              className="btn btn-dark"
            >
              Submit
            </button>
          </form>
        </div>
      ) : show == "add" ? (
        <div className="cus-contact">
          <form>
            {/* <h3>About Us</h3> */}
            <div className="form-group">
              <label>Title</label>
              <input
                class="form-control"
                value={title}
                onChange={(e) => settitle(e.target.value)}
              ></input>
            </div>
            <div className="form-group">
              <label>Description</label>
              <input
                class="form-control"
                value={description}
                onChange={(e) => setdescription(e.target.value)}
              ></input>
            </div>

            <div className="form-group">
              <label>Image</label>
              <input
                type="file"
                className="form-control"
                // value={link2}
                name="image"
                onChange={(e) => setimage(e.target.files[0])}
              />
            </div>
            <div className="form-group">
              <img
                src={updateimage}
                alt=""
                className="img-fluid"
                style={{ width: 200, height: 200 }}
              />
            </div>
            <button
              onClick={() => {
                handleImage();
              }}
              type="button"
              className="btn btn-dark"
            >
              Submit
            </button>
          </form>
        </div>
      ) : (
        <div className="content">
          <div className="row table-invoice">
            <div className="col-sm-12">
              <div className="table-in-card">
                <div class="d-flex justify-content-between">
                  <h3>Home Benefits Meal Section</h3>
                  {data.length == 0 ? (
                    <button
                      type="button"
                      onClick={() => setShow("add")}
                      class="btn btn-primary btn-xs"
                    >
                      <small>Add</small>
                    </button>
                  ) : null}
                </div>
                {data.length > 0 ? (
                  <>
                    <br />

                    <div className="table-responsive">
                      <table className="table table-striped">
                        <thead>
                          <tr>
                            <th>Image</th>
                            <th>Title</th>
                            <th>Description</th>
                            <th>Action</th>
                          </tr>
                        </thead>
                        <tbody>
                          {data == undefined
                            ? null
                            : data.map((item) => {
                                return (
                                  <tr>
                                    <td>
                                      <img
                                        src={URLs.images + item.image}
                                        alt=""
                                        className="img-fluid"
                                        style={{ width: 100, height: 100 }}
                                      />
                                    </td>
                                    <td>{item.title}</td>
                                    <td>{item.description}</td>

                                    <td>
                                      <div class="d-flex justify-content-evenly">
                                        <button
                                          type="button"
                                          onClick={() => UpdateItem(item)}
                                          class="btnnnnn btn-primary"
                                          style={{ marginRight: 10 }}
                                        >
                                          <i class="fa fa-edit"></i>
                                        </button>
                                        <button
                                          type="button"
                                          onClick={() =>
                                            handlerDelete(item._id, item.image)
                                          }
                                          class="btnnnnn btn-danger"
                                        >
                                          <i class="fa fa-trash"></i>
                                        </button>
                                      </div>
                                    </td>
                                  </tr>
                                );
                              })}
                        </tbody>
                      </table>
                    </div>
                  </>
                ) : null}
              </div>
            </div>
          </div>
        </div>
      )}
    </>
  );
}

export default BenefitsMeal;
